import React from 'react'
import { Link } from 'gatsby'

import * as styles from './mainfooter.module.scss'
import { IconYoutube } from '../libs/icons'
import fOneRed from '../images/f1_red.png'
import fOneWhite from '../images/f1_white.png'

const handleOsano = () => {
  window.Osano.cm.showDrawer('osano-cm-dom-info-dialog-open')
}

const MainFooter = () => {
  return (
    <div id="main-footer" className="link-list">
      <div className={styles['inner']}>
        <div className={styles['questions'] + ' other footer-right-side'}>
          <div>
            <h3>Have questions?</h3>
            <span>Get answers.</span>
            <Link to="/contact-a-recruiter" className="recruiter-box">
              Contact a Recruiter
            </Link>
          </div>
        </div>
        <div className={styles['links']}>
          <div>
            <div className={styles['groupMmd']}>
              <h2>Military Medical Divisions</h2>
              <ul>
                <li>
                  <a
                    className="external"
                    href="https://www.goarmy.com/careers-and-jobs/specialty-careers/health-care.html?iom=BQHV-2772509_N_AP_JAMRS_MedicineAndMilitary_Website_FOOTER_xx"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Army
                  </a>
                </li>
                <li>
                  <a
                    className="external"
                    href="https://www.goarmy.com/careers-and-jobs/specialty-careers/health-care.html?iom=BQHV-2772509_N_AP_JAMRS_MedicineAndMilitary_Website_FOOTER_xx"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Army Reserve
                  </a>
                </li>
                <li>
                  <a
                    className="external"
                    href="https://jobs.nationalguard.com/categories/396/medical-jobs/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Army National Guard
                  </a>
                </li>
              </ul>
              <ul>
                <li>
                  <a
                    className="external"
                    href="https://www.airforce.com/careers/specialty-careers/healthcare"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Air Force
                  </a>
                </li>
                <li>
                  <a
                    className="external"
                    href="https://www.airforce.com/ways-to-serve/locations"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Air Force Reserve
                  </a>
                </li>
                <li>
                  <a className="external" href="https://www.airforce.com/careers" target="_blank" rel="noreferrer">
                    Air National Guard
                  </a>
                </li>
              </ul>
              <ul>
                <li>
                  <a
                    className="external"
                    href="https://www.navy.com/careers-benefits/careers/medical?q=careers/medical"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Navy
                  </a>
                </li>
                <li>
                  <a
                    className="external"
                    href="https://www.navy.com/careers-benefits/careers/medical?q=careers/medical"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Navy Reserve
                  </a>
                </li>
              </ul>
            </div>
            <div className={styles['group'] + ' other second-column--footer'}>
              <h2>Other Links</h2>
              <ul>
                <li>
                  <Link to="/about-us">About</Link>
                </li>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/external-link-policy">External Link Policy</Link>
                </li>
                <li>
                  <Link to="/site-accessibility">Site Accessibility</Link>
                </li>
                <li>
                  <Link to="/military-physician-faq">
                    FAQ<span>s</span>
                  </Link>
                </li>
                <li>
                  <button className={styles['cookieBtn']} onClick={handleOsano}>
                    Cookie Preferences
                  </button>
                </li>
              </ul>
            </div>
            <div className={styles['groupFollow']}>
              <h2>Follow Us</h2>
              <ul>
                <li>
                  <a
                    className="external"
                    href="https://app.figure1.com/rd/publicprofile?username=medandthemilitary"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span className={styles['iconFigOne']}>
                      <img src={fOneRed} width={20} alt="Figure 1 icon" />
                      <img src={fOneWhite} width={20} alt="Figure 1 icon" />
                    </span>
                    <span className="screen-reader-text" style={{ display: 'none' }}>
                      Figure One
                    </span>
                  </a>
                </li>
                <li>
                  <a
                    className="external"
                    href="https://www.youtube.com/channel/UCFiK9BQp4Uwj3CD-qTLD6fw"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Medicine + The Military Youtube channel"
                  >
                    <span className={styles['iconYoutube']}>
                      <IconYoutube height={16} />
                    </span>
                    <span className="screen-reader-text" style={{ display: 'none' }}>
                      YouTube
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className={styles['legal']}>
          <div>
            <p>The Department of Defense</p>
            <p>{new Date().getFullYear()} Medicine + The Military</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MainFooter
